import { CircularProgress, Grid, withStyles } from '@material-ui/core';
import React from 'react';

const styles = theme => ({
  root: {
    userSelect: 'none',
    justifyContent: 'inherit',
  },
  progress: {
    marginRight: theme.spacing(3),
  },
});

function LoadingIndicator({ classes, children, ...rest }) {
  return (
    <Grid className={classes.root} component="span" container wrap="nowrap" alignItems="center">
      <CircularProgress variant="indeterminate" className={classes.progress} size={24} color="inherit" {...rest} />
      {children}
    </Grid>
  );
}

export default withStyles(styles)(LoadingIndicator);
